module.exports = __webpack_public_path__ + "img/barrel.fef36dca.svg";